import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeliveryDevices } from 'app/dtos/device/deliveryDeivce';
import { _isId } from 'app/services/auth.service';
import { BrandService } from 'app/services/models/brand.service';
import { CompanyService } from 'app/services/models/company.service';
import { DeviceService } from 'app/services/models/device.service';
import { KindService } from 'app/services/models/kind.service';
import { PersonService } from 'app/services/models/person.service';
import { deliveryDevicesValidator } from 'app/validators/deliveryDevicesValidator';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device-delivery-dialog',
  templateUrl: './device-delivery-dialog.component.html',
  styleUrls: ['./device-delivery-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeviceDeliveryDialogComponent implements OnInit {
  @Input() data: { kindId: number; message:string, companyId: number; };

  date = new Date();


  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate:this.date
  };

  constructor(
    private brandService: BrandService,
    private fb: FormBuilder,
    private kindSerivce: KindService,
    private companyService: CompanyService,
    public activeModal: NgbActiveModal,
    private deviceSerivce: DeviceService,
    private personSerivce: PersonService,
    private toastrService: ToastrService,
    private modalService: NgbModal) {

    this.deviceForm = this.fb.group({
      companyId: [null, Validators.required], // Tek firma seçimi
      companyPersonId: [null, Validators.required],
      description: [null],
      movementDate: [null],
      selectedDevices: [null],
      createDevicesList: this.fb.array([]) // Birden fazla ürün formu
    },{ validators: deliveryDevicesValidator() });
  }

  deviceForm: FormGroup;
  brands: any[];
  kinds: any[];
  companies: any[];
  companyPersons: any[];
  companyDevice: any[];

  async ngOnInit() {
    await this.getAllBrand();
    await this.getAllKinds();
    await this.getAllCompaines();
    console.log(this.data);

    if (this.data.companyId) {
      this.deviceForm.patchValue({
        companyId: Number(this.data.companyId)
      });
      await this.getAllCompanyPersons(this.data.companyId);
    }

    this.deviceForm.get('companyId').valueChanges.subscribe(async (companyId) => {
      if (companyId) {
        await this.getAllCompanyPersons(companyId);
        await this.getByIdCompanyDevices(companyId);
      }
    });
  }

  findDeviceById(id: any): string {
    const device = this.companyDevice.find(d => d.id === id);
    return device ? device.seriNo : 'Bilinmiyor';
  }

  createProductForm(): FormGroup {
    return this.fb.group({
      brandModelId: [null, Validators.required],
      kindId: [null, Validators.required],
      seriNo: ['', Validators.required],
      period: [null],
      description:[null]
    });
  }


  get createDevicesList(): FormArray {
    return this.deviceForm.get('createDevicesList') as FormArray;
  }

  addProduct() {
    this.createDevicesList.push(this.createProductForm());
  }

  removeProduct(index: number) {
    this.createDevicesList.removeAt(index);
  }

  async getByIdCompanyDevices(id) {
    const data = await this.deviceSerivce.getAllCompanyDevices(0, 1000, '', id);
    this.companyDevice = data.devices;
    console.log(this.companyDevice);

  }

  async getAllKinds() {
    const data = await this.kindSerivce.getAllKinds('', 0, 100, 13);
    console.log(data);
    this.kinds = data.types;
  }

  async getAllCompaines() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async getAllCompanyPersons(companyId) {
    const data = await this.personSerivce.getAllCompaniesPersons(0, 1000, companyId);
    this.companyPersons = data.persons;
    console.log(data);
  }


  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );
    console.log(this.brands);
  }


  async onSubmit() {
    const products = this.deviceForm.value.createDevicesList;
    console.log(products);

    const selectedDevices = this.companyDevice.filter(d =>
      this.deviceForm.value.selectedDevices?.includes(d.id)
    );
    console.log(selectedDevices);

    // Benzersiz anahtarları kontrol et
    const uniqueKeys = new Set(products.map(p => `${p.brandModelId}-${p.seriNo}`));
    if (uniqueKeys.size !== products.length) {
      this.toastrService.error('Aynı seri numarası ve marka/model kombinasyonuyla ürün ekleyemezsiniz.');
      return;
    }

    // SelectedDevices ve Products arasında eşleşme kontrolü
    const hasConflict = products.some(product =>
      selectedDevices.some(device =>
        product.brandModelId === device.brandModelId && product.seriNo === device.seriNo
      )
    );

    if (hasConflict) {
      this.toastrService.error('Seçilen cihazlar arasında aynı marka/model ve seri numarasına sahip öğe var.');
      return;
    }

    const movementDate = new Date(this.deviceForm.value.movementDate[0]);
    console.log(movementDate);
    console.log('Validation passed', this.deviceForm.value);
    const deliveryDevice = new DeliveryDevices();
    deliveryDevice.appUserId = _isId;
    deliveryDevice.companyId = this.deviceForm.value.companyId;
    deliveryDevice.companyPersonId = this.deviceForm.value.companyPersonId;
    deliveryDevice.createDevices = this.deviceForm.value.createDevicesList;
    deliveryDevice.description = this.deviceForm.value.description;
    deliveryDevice.kindId = this.data.kindId;
    deliveryDevice.selectedDevices = this.deviceForm.value.selectedDevices;
    deliveryDevice.movementDate = movementDate;
    const response = await this.deviceSerivce.deliveryDevice(deliveryDevice);
    if (response.status == true) {
      this.deviceSerivce.sendEvent(true);
      this.toastrService.success(response.message);
      this.closeModal();
    } else {
      this.toastrService.error(response.message);
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }
}